export default __webpack_public_path__ + "static/jm-a00804c651028a5a7aef34fc7718af46.jpg";